import { adminCompaniesEndpoints } from "@/constants";
import { axiosClient } from "@/services/axios-client";
import { transformApiBenchmarkListItemHandler, transformApiCompanyHandler } from "@/services/shared";
import type {
    ApiBenchmarkListItemType,
    ApiCompanyType,
    CompanyType,
} from "@/types";

interface ApiCompanyDetailEnvelopeInterface {
    benchmarks?: ApiBenchmarkListItemType[],
    company?: ApiCompanyType,
    data?: ApiCompanyType,
    result?: ApiBenchmarkListItemType[],
    results?: ApiBenchmarkListItemType[],
}

export const getCompanyByIdHandler = async (id: number | string): Promise<CompanyType> => {
    const response = await axiosClient.get<ApiCompanyDetailEnvelopeInterface | ApiCompanyType>(adminCompaniesEndpoints.byId(id));

    const envelope = response.data as ApiCompanyDetailEnvelopeInterface;

    const company = envelope.company ?? envelope.data ?? (response.data as ApiCompanyType);

    const benchmarksRaw = company.benchmarks
        ?? company.result
        ?? company.results
        ?? envelope.benchmarks
        ?? envelope.result
        ?? envelope.results
        ?? [];

    const benchmarks = benchmarksRaw.map(transformApiBenchmarkListItemHandler);

    return {
        ...transformApiCompanyHandler(company),
        benchmarks,
    };
};
